import axios from 'axios';
import { access_token, isTokenExpired, refreshAuthToken } from '../../utils/getAccessToken';
import { getURLFromFunctionName } from '../../utils/shared';
import { FlowScenario } from '../../types/flowScenario';

export async function createStripeCheckoutSession(flowScenario: FlowScenario): Promise<string> {
  if (!access_token || isTokenExpired(access_token)) {
    await refreshAuthToken();
  }

  const response = await axios.post(
    getURLFromFunctionName('stripePaymentHandler'),
    {
      data: {
        baseUrl: window.location.origin,
        flowScenario,
        skipRedirect: true,
      },
    },
    {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    }
  );

  if (!response.data || !response.data.data) {
    throw new Error('No data found');
  }

  console.log(response.data.data.clientSecret);

  return response.data.data.clientSecret;
}
